export default "__VITE_ASSET__DS0h_Sbm__"